import React, {useEffect, useState} from 'react'
import {connect} from "react-redux";
import {adminHttp} from "~/Admin/services/http";
import AdminEventTracksideItem from "./AdminEventTracksideItem";
import AdminDndList from "~/Admin/AdminDndList/AdminDndList";

const AdminEventTrackside = ({match, event, onChange, ...props}) => {

    const [selectedId, setSelectedId] = useState(event.trackside_experiences[0]?.id || 0);

    const handleOrderChanged = (data) => {
        adminHttp.put('/events/' + event.id + '/experiences/order', {
            data: data.map(i => i.id)
        });
    }

    const handleAdd = () => {
        adminHttp.post('/events/' + event.id + '/experiences', {
            type: 'trackside'
        }).then(res => {
            if (onChange) {
                onChange();
            }
        });
    }

    const selectedExp = event.trackside_experiences.find(item => item.id === selectedId);

    return (
        <div>
            <div className="card shadow-sm bg-white">
                <div className="card-body">
                    <div className="row">
                        <div className="col-12">
                            <h3>Trackside Experiences</h3>
                        </div>
                        <div className="col-4">
                            <AdminDndList
                                key={event.updated_at}
                                onChanged={handleOrderChanged}
                                onSelect={setSelectedId}
                                selected={selectedId}
                                list={event.trackside_experiences} />

                                <button
                                    onClick={handleAdd}
                                    className="btn btn-primary btn-sm w-100">+ Add Experience</button>
                        </div>
                        <div className="col-8">
                            {selectedExp && <AdminEventTracksideItem
                                key={selectedId}
                                onChange={onChange}
                                onDelete={onChange}
                                experience={selectedExp} />}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => ({
    user: state.auth?.user,
    event: state.event.current,
});

export default connect(mapStateToProps)(AdminEventTrackside);
